import React from 'react'
import { CNavGroup, CNavItem } from '@coreui/react'

import trading_nav from 'src/modules/trading/_nav'
import account_nav from 'src/modules/account/_nav'
import inventory_management_nav from 'src/modules/inventory-management/_nav'
import human_resource_management_nav from 'src/modules/human-resource-management/_nav'
import project_management_nav from 'src/modules/project-management/_nav'
import job_management from 'src/modules/job-management/_nav'
import questionnaire_management from 'src/modules/questionnaire-management/_nav'
import meeting_management from 'src/modules/meeting-management/_nav'
import _modules from './_modules'
import business_entities from './collectionsStructure/business_entities'
import business_entity_notices from './collectionsStructure/business_entity_notices'
import document_types from './collectionsStructure/document_types'
import email_logs from './collectionsStructure/email_logs'
import external_documents from './collectionsStructure/external_documents'
import regions from './collectionsStructure/regions'
import staffs from './collectionsStructure/staffs'
import users from './collectionsStructure/users'
import e_signs from './collectionsStructure/e_signs'

let _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <i className="material-icons-round">dashboard</i>,
  },
]

// import modules nav link
_nav = _nav.concat(trading_nav) // Trading module
_nav = _nav.concat(account_nav) // Account module
_nav = _nav.concat(inventory_management_nav) // Inventory Management module
_nav = _nav.concat(human_resource_management_nav) // Human Resource Management module
_nav = _nav.concat(project_management_nav) // Project Management module
_nav = _nav.concat(job_management) // Job Management module
_nav = _nav.concat(meeting_management) // Meeting Management module
_nav = _nav.concat(questionnaire_management) // Questionnaire Management module

if (
  _modules.business_entities ||
  _modules.business_entity_notices ||
  _modules.document_types ||
  _modules.email_logs ||
  _modules.external_documents ||
  _modules.regions ||
  _modules.staffs ||
  _modules.users ||
  _modules.e_signs
) {
  const general_items = {
    component: CNavGroup,
    name: 'General',
    icon: <i className="material-icons-outlined">miscellaneous_services</i>,
    items: [],
  }

  if (_modules.business_entities)
    general_items.items.push({
      component: CNavItem,
      name: 'Business Entities',
      to: '/business-entities',
      permissionSource: business_entities.permissionSource,
      icon: <i className="material-icons-outlined">business</i>,
    })
  if (_modules.business_entity_notices)
    general_items.items.push({
      component: CNavItem,
      name: 'Business Entity Notices',
      to: '/business-entity-notices',
      permissionSource: business_entity_notices.permissionSource,
      icon: <i className="material-icons-outlined">business</i>,
    })
  if (_modules.document_types)
    general_items.items.push({
      component: CNavItem,
      name: 'Document Types',
      to: '/document-types',
      permissionSource: document_types.permissionSource,
      icon: <i className="material-icons-outlined">document_scanner</i>,
    })
  if (_modules.email_logs)
    general_items.items.push({
      component: CNavItem,
      name: 'Email History',
      to: '/email-logs',
      permissionSource: email_logs.permissionSource,
      icon: <i className="material-icons-outlined">email</i>,
    })
  if (_modules.external_documents)
    general_items.items.push({
      component: CNavItem,
      name: 'External Documents',
      to: '/external-documents',
      permissionSource: external_documents.permissionSource,
      icon: <i className="material-icons-outlined">file_copy</i>,
    })
  /*if (_modules.regions)
    general_items.items.push({
      component: CNavItem,
      name: 'Regions',
      to: '/regions',
      permissionSource: regions.permissionSource,
      icon: <i className="material-icons-outlined">my_location</i>,
    })*/
  if (_modules.staffs)
    general_items.items.push({
      component: CNavItem,
      name: 'Staffs',
      to: '/staffs',
      permissionSource: staffs.permissionSource,
      icon: <i className="material-icons-outlined">manage_accounts</i>,
    })
  if (_modules.users)
    general_items.items.push({
      component: CNavItem,
      name: 'Users',
      to: '/users',
      permissionSource: users.permissionSource,
      icon: <i className="material-icons-outlined">verified_user</i>,
    })
  if (_modules.e_signs)
    general_items.items.push({
      component: CNavItem,
      name: 'E-Signs',
      to: '/e-signs',
      permissionSource: e_signs.permissionSource,
      icon: <i className="material-icons-outlined">lens_blur</i>,
    })

  _nav.push(general_items)
}

if (
  _modules.trading_report ||
  _modules.account_report ||
  _modules.inventory_management_report ||
  _modules.human_resource_management_report ||
  _modules.project_management_report
) {
  const report_items = {
    component: CNavGroup,
    name: 'Report',
    icon: <i className="material-icons-outlined">assessment</i>,
    items: [],
  }

  if (_modules.trading_report)
    report_items.items.push({
      component: CNavItem,
      name: 'Trading Report',
      to: '/trading-report',
      permissionSource: 'api::trading-setting.trading-setting',
      icon: <i className="material-icons-outlined">assessment</i>,
    })
  if (_modules.account_report)
    report_items.items.push({
      component: CNavItem,
      name: 'Account Report',
      to: '/account-report',
      permissionSource: 'api::account-setting.account-setting',
      icon: <i className="material-icons-outlined">assessment</i>,
    })
  if (_modules.inventory_management_report)
    report_items.items.push({
      component: CNavItem,
      name: 'Inventory Report',
      to: '/inventory-management-report',
      permissionSource: 'api::inventory-setting.inventory-setting',
      icon: <i className="material-icons-outlined">assessment</i>,
    })
  if (_modules.human_resource_management_report)
    report_items.items.push({
      component: CNavItem,
      name: 'HR Report',
      to: '/human-resource-management-report',
      permissionSource: 'api::hrm-setting.hrm-setting',
      icon: <i className="material-icons-outlined">assessment</i>,
    })
  if (_modules.project_management_report)
    report_items.items.push({
      component: CNavItem,
      name: 'Project Report',
      to: '/project-management-report',
      permissionSource: 'api::project-management.project-management',
      icon: <i className="material-icons-outlined">assessment</i>,
    })

  _nav.push(report_items)
}

export default _nav
